import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-parent",
  "use": "transaction-parent-usage",
  "viewBox": "0 0 18.84 18.15",
  "content": "<symbol viewBox=\"0 0 18.84 18.15\" id=\"transaction-parent\"><title>BatchAsset 7</title><path d=\"M16.61,10.22V8.72H10.19V7.11h8.06V0H.63V7.11H8.69V8.72H2.28v1.5h0v1.72H0v6.21H5.49V11.94H3.79V10.22h4.9v1.72h-2v6.21h5.53V11.94h-2V10.22h4.92v1.72H13.4v6.21h5.45V11.94H16.61ZM4,16.65H1.5V13.44H4Zm6.72,0H8.18V13.44h2.53Zm6.64,0H14.9V13.44h2.45Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol